import { render, staticRenderFns } from "./ListEventos.vue?vue&type=template&id=7bdc886e&"
import script from "./ListEventos.vue?vue&type=script&lang=js&"
export * from "./ListEventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports